import http from "../http-common";
import { Row } from "../models/rowModel";

class RowDataService {
    async createRow(row: Row) {
        const json = JSON.stringify(row);
        return await http.post("/rows/create", json);
    }

    async updateRow(row: Row) {
        const json = JSON.stringify(row);
        return await http.post("/rows/update", json);
    }

    async deleteRows(rows: Row[]) {
        const json = JSON.stringify(rows);
        return await http.post("/rows/delete", json);
    }

    async moveRows(rows: Row[]) {
        const json = JSON.stringify(rows);
        return await http.post("/rows/move", json);
    }

    async copyRows(rows: Row[]) {
        const json = JSON.stringify(rows);
        return await http.post("/rows/copy", json);
    }
}

export default new RowDataService();